import React from "react";
import { Typography } from "@trussle/external-components";
import { StaticImage } from "gatsby-plugin-image";
import { IContentfulRichTextResponse } from "../../../../types/IContentfulRichText";
import { RichText } from "../../../RichText";

import { transformRichText } from "../../../../helpers/richText";
import "./styles.scss";
import { PanelWrapper } from "../../../PanelWrapper";

export interface IWhatWeOfferPanelProps {
  mainContent?: IContentfulRichTextResponse;
  title?: string;
}

export const WhatWeOfferPanel: React.FunctionComponent<IWhatWeOfferPanelProps> = ({
  mainContent,
  title,
}) => {
  const contentRichTxt = mainContent && transformRichText(mainContent.raw);

  return (
    <PanelWrapper
      isBetterV2
      className="what-we-offer-panel"
    >
      <Typography variant="h1" component="h2" classes="what-we-offer-panel__title">{title}</Typography>
      <div className="what-we-offer-panel__content">
        <div className="what-we-offer-panel__content__purple-square_wrapper">
          <StaticImage
            src="./purple_square_shape.png"
            alt=""
            className="what-we-offer-panel__content__purple-square"
            placeholder="none"
            width={470}
            height={457}
            loading="lazy"
          />
        </div>
        <RichText
          content={contentRichTxt}
          className="what-we-offer-panel__content__text"
        />
      </div>
    </PanelWrapper>
  );
};
